module.exports = __webpack_public_path__ + "static/img/dataNone.74373781.png";